import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { MfaSmsVerify } from "./MfaSmsVerify";
import { routes } from "./MfaSmsVerify.Parts";

// LOADER

// WRAPPER

// ROUTE
export const MfaSmsVerifyRouteObject: RouteObject = {
  path: routes.mfa.sms.verify,
  errorElement: <GeneralErrorPage />,
  Component: MfaSmsVerify,
};
